
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TextField, Button, Box, Typography, MenuItem } from '@mui/material';

const EditUser = ({ user, onClose, onUpdate }) => {
    const [formData, setFormData] = useState({
        username: user.username || '',
        email: user.email || '',
        password: '',
        role: user.role || 'user',
        icon: user.icon || 'Person',
    });

    useEffect(() => {
        setFormData({
            username: user.username || '',
            email: user.email || '',
            password: '',
            role: user.role || 'user',
            icon: user.icon || 'Person',
        });
    }, [user]);

    const { username, email, password, role, icon } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        try {
            const res = await axios.put(`/api/users/${user.id}`, formData);
            onUpdate(res.data);
            onClose();
        } catch (err) {
            console.error(err.response.data);
        }
    };

    return (
        <Box component="form" onSubmit={onSubmit} sx={{ mt: 1 }}>
            <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                Редактировать пользователя
            </Typography>
            <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="Имя пользователя"
                name="username"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={onChange}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={email}
                onChange={onChange}
            />
            <TextField
                margin="normal"
                fullWidth
                name="password"
                label="Новый пароль"
                type="password"
                id="password"
                autoComplete="new-password"
                value={password}
                onChange={onChange}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                id="role"
                select
                label="Роль"
                name="role"
                value={role}
                onChange={onChange}
            >
                <MenuItem value="root">root</MenuItem>
                <MenuItem value="admin">admin</MenuItem>
                <MenuItem value="user">user</MenuItem>
            </TextField>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
            >
                Обновить
            </Button>
            <Button
                fullWidth
                variant="outlined"
                sx={{ mb: 2 }}
                onClick={onClose}
            >
                Отмена
            </Button>
        </Box>
    );
};

export default EditUser;
